/* tslint:disable */
/* eslint-disable */

/**
 * 1 = PDF
 * 2 = JPEG
 */
export enum TypeFichierPieceJointeValues {
  PDF = 1,
  JPEG = 2
}
